import { InfoCircleOutlined } from "@ant-design/icons";

export default function StatsCard() {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* CARD 1 */}
            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-center gap-4 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                        <InfoCircleOutlined className="text-blue-500" />
                        <span>Đơn hàng mới</span>
                    </div>
                    <span className="text-[16px] text-gray-800 dark:text-gray-200 font-medium">0</span>
                </div>

                {/* Body */}
                <div className="grid grid-cols-2 text-center">
                    <div className="py-4 border-r border-gray-200 dark:border-gray-700">
                        <div className="text-lg font-semibold text-gray-800 dark:text-white">
                            0
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            Tổng tiền
                        </div>
                    </div>

                    <div className="py-4">
                        <div className="text-lg font-semibold text-gray-800 dark:text-white">
                            0
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            Tiền cọc
                        </div>
                    </div>
                </div>
            </div>

            {/* CARD 2 */}
            <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">

                {/* Header */}
                <div className="flex items-center justify-center gap-4 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                        <InfoCircleOutlined className="text-blue-500" />
                        <span>Tổng chi tiêu</span>
                    </div>
                    <span className="text-[16px] text-gray-800 dark:text-gray-200 font-medium">0</span>
                </div>

                {/* Body */}
                <div className="grid grid-cols-2 text-center">
                    <div className="py-4 border-r border-gray-200 dark:border-gray-700">
                        <div className="text-lg font-semibold text-gray-800 dark:text-white">
                            0
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            Hóa đơn sử dụng dịch vụ
                        </div>
                    </div>

                    <div className="py-4">
                        <div className="text-lg font-semibold text-gray-800 dark:text-white">
                            0
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            Hóa đơn mua sản phẩm
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}